import { i18n } from '@lingui/core';
import type {
    FilterItem,
    StandardFilter as TStandardFilter,
} from '@schibsted-nmp/search-frontend-clients/quest';
import { Button } from '@warp-ds/react';
import React from 'react';

export function usePopularItems(filter: TStandardFilter) {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const isPopularItemsFilter =
        typeof filter.item_display_count !== 'undefined' &&
        filter.item_display_count < filter.filter_items.length;

    const filterItems = React.useMemo(
        () =>
            isPopularItemsFilter && !isExpanded
                ? getSelectedAndPopularItems(filter)
                : filter.filter_items,
        [filter, isExpanded, isPopularItemsFilter],
    );

    const expandCollapseButton = isPopularItemsFilter ? (
        <Button
            link
            small
            className="mt-8"
            onClick={() => setIsExpanded((prev) => !prev)}
            aria-expanded={isExpanded}
        >
            {isExpanded
                ? i18n.t({
                      id: 'filters.popular.collapse',
                      message: 'Show fewer',
                      comment:
                          'Collapse the filter and show just the most frequent/common values',
                  })
                : i18n.t({
                      id: 'filters.popular.expand',
                      message: 'Show all',
                      comment: 'Expand the filter and show all values',
                  })}
        </Button>
    ) : null;

    return {
        expandCollapseButton,
        filterItems,
    };
}

function getSelectedAndPopularItems(filter: TStandardFilter): FilterItem[] {
    const popularItemValues = filter.filter_items
        .slice()
        .sort((a, b) => b.hits - a.hits)
        .slice(0, filter.item_display_count)
        .map((item) => item.value);

    return filter.filter_items.filter(
        (item) => item.selected || popularItemValues.includes(item.value),
    );
}
